import { Popup } from './Popup'
import type { Vacancy } from './types/vacancies'

export const initializedContainers = new Set<HTMLElement>()

export const data: { vacancies: Vacancy[] } = { vacancies: [] }

export const popup = new Popup()
